export default {
      id: "heart-usage",
      viewBox: "0 0 14 12",
      url: __webpack_public_path__ + "sprite.svg#heart",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/heart.svg
// module id = 132
// module chunks = 241 242 243